import(/* webpackMode: "eager" */ "/vercel/path0/src/app/universities-portugal/page.tsx");
